import { render, staticRenderFns } from "./pageIndex.vue?vue&type=template&id=06e656d4&scoped=true"
import script from "./pageIndex.vue?vue&type=script&lang=js"
export * from "./pageIndex.vue?vue&type=script&lang=js"
import style0 from "./pageIndex.vue?vue&type=style&index=0&id=06e656d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e656d4",
  null
  
)

export default component.exports